import { CustomForm } from '../../../shared/components/index';
import { Box, Typography, Card } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldType } from '../../../shared/components/form-field/service/formFieldInterface';
import {
  I18N,
  TENANT_ROLES,
  ROLES,
  PAYMENT_METHOD
} from '../../../shared/constants/constants';
 
import { useSelector } from 'react-redux';
import { selectUserState } from 'src/auth/login/services/userSlice';
const AddExpenceModal = ({
  isAddModal,
  open,
  onSubmit,
  assets,
  handleClose,
  editObject
}) => {
  const [fields, setFields] = useState([] as FormFieldType[]);
  const { i18n, t } = useTranslation(I18N.DEFAULT);
  const { loginUserRole } = useSelector(selectUserState);
  const configurableRole =
    loginUserRole == ROLES.TENANT_OPERATOR
      ? [TENANT_ROLES[1], TENANT_ROLES[2]]
      : TENANT_ROLES;

  const [initialValues, setInitialValues] = useState({
    asset: '',
    description: '',
    date: new Date(),
    amount: '',
    name: '',
    paymentMethod: '',
  });

  const baseCustomFormFields: FormFieldType[] = [
    {
      id: 'asset',
      name: 'asset',
      type: 'autocomplete',
      options: assets,
      label: t('expense.asset'),
      itemValueKey: 'id',
      itemLabelKey: 'label',
      col: 1.5
    },
    {
      id: 'name',
      name: 'name',
      type: 'multi-text',
      label:  t('name'),
      col: 1.6,
      validations: {
        required: true,
      },
    },
    {
      id: 'description',
      name: 'description',
      type: 'multi-text',
      label: t('table.description'),
      col: 2,
      errorMessages: {
        requiredErrMsg: 'Description is required',
      }
    },
    {
      id: 'date',
      name: 'date',
      type: 'date',
      label: t('table.date'),
      col: 1.6,
      validations: {
        required: true,
        maxLength: 50
      },
      errorMessages: {
        requiredErrMsg: 'name is required'
      }
    },
    {
      id: 'amount',
      name: 'amount',
      type: 'integer_only',
      label: t('table.amount'),
      col: 1.5,
      itemValueKey: 'id',
      validations: {
        required: true
      },
      errorMessages: {
        requiredErrMsg: 'Amount is required'
      }
    },
    {
      id: 'paymentMethod',
      name: 'paymentMethod',
      type: 'autocomplete',
      options: PAYMENT_METHOD,
      label: t('table.payment-method'),
      itemValueKey: 'id',
      itemLabelKey: 'name',
      col: 1.6,
      validations: {
        required: true
      },
      errorMessages: {
        requiredErrMsg: 'Payment method is required'
      }
    }
  ];

  useEffect(() => {
    if (isAddModal) {
      handleAddUserButtonClick();
    } else {
      handleEditIconClick(editObject);
    }
  }, [open]);

  const handleAddUserButtonClick = () => {
    const fields = [
      ...baseCustomFormFields,
    ];
    setFields(fields);
  };

  const handleEditIconClick = (row) => {
    const formFields = [...baseCustomFormFields];
    formFields.map((field) => {
      field.isDisabled = true;
      return field;
    });
    setFields([...formFields,]);

    const initialFormValue = {
      asset: row.asset,
      description: row.Description,
      date: row.date,
      amount: row.amount,
      name: row.name,
      paymentMethod: row.paymentMethod?.id
    };
    setInitialValues(initialFormValue);
  };

  return (
    <Card className="mb-24">
      {' '}
      <Typography sx={{ p: 3, pl: 2 }} variant="h4" fontWeight="bold">
        {isAddModal ? t('expense.add-expence') : t('expense.edit-expence')}
      </Typography>
      <Box sx={{ p: 1 }}>
        <CustomForm
          formFields={fields}
          enableReinitialize={true}
          editFieldValues={initialValues}
          initialValues={initialValues}
          submitBtnHandler={onSubmit}
          cancelBtnHandler={handleClose}
        />
      </Box>
    </Card>
  );
};

export default AddExpenceModal;
